// extracted by mini-css-extract-plugin
export default {"main":"WebviewPage_main__ZcqG8","loader":"WebviewPage_loader__4W675","loaderText":"WebviewPage_loaderText__S2FSb","error":"WebviewPage_error__E95Te"};